import React, { useState, useContext } from "react";
import "./Subscription.css";
import propTypes from "prop-types";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router";
import { AuthContext } from "../../context/AuthContext";
import ProductDisplay from "./ProductDisplay";
import EnterPaymentInfo from "./EnterPaymentInfo";
import SuccessDisplay from "./SuccessDisplay";
const stripePromise = loadStripe(
  "pk_test_51P5EWwDzUa3kQmx1ilspDEV8ujic4DJ1Jj8cvbE21xiBVHClxAeQq4cG7k10PqljSPs5irYQF1OuTdl4FIwG0heW00n2ByNZAQ"
);

const Message = ({ message }) => (
  <section>
    <p>{message}</p>
  </section>
);

export default function Subscription() {
  const [paymentStep, setPaymentStep] = useState(1);
  const [success, setSuccess] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const { user } = useContext(AuthContext);
  const { username } = useParams();
  console.log("subscriptionUsername", username);
  const navigate = useNavigate();
  // Define the appearance object
  const appearance = {
    theme: "night",
    labels: "floating", // Floating labels as per documentation
    variables: {
      colorPrimary: "rgb(17, 164, 255)",
      colorBackground: "rgb(21, 24, 25)",
      colorText: "#ffffff",
      colorDanger: "#ff4444",
      fontFamily: "Inter, sans-serif",
      // spacingUnit: "4px",
      borderRadius: "8px",
    },
    rules: {
      ".Input": {
        border: "1px solid #444",
        padding: "4px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        height: "8px",
      },
      ".Input:focus": {
        border: "1px solid rgb(17, 164, 255)",
        boxShadow: "0 0 0 2px rgba(0, 123, 255, 0.2)",
      },
      ".Label": {
        fontSize: "12px",
        fontWeight: "500",
        color: "#cccccc",
      },
      button: {
        height: "10px",
      },
      ".Tab": {
        border: "1px solid #444",
        backgroundColor: "#2a2f45",
        color: "#ffffff",
      },
      ".Tab--selected": {
        backgroundColor: "#007bff",
        color: "#ffffff",
        border: "1px solid rgb(17, 164, 255)",
      },
    },
  };

  if (user.username !== username) {
    navigate("/");
  }

  // if(user.isSubscribed){
  //   console.log("user: ", user);
  //   return (
  //       <div className="user-already-sub">
  //           <h3>{`You are already subscribed \u{1F389}`}</h3>
  //       </div>
  //   )
  // }

  return (
    <div className="prod-display-container">
      {paymentStep === 1 && user.username === username && (
        <ProductDisplay
          setPaymentStep={setPaymentStep}
          setClientSecret={setClientSecret}
        />
      )}
      {paymentStep === 2 && clientSecret && user.username === username && (
        <div className="step2">
          <Elements
            stripe={stripePromise}
            options={{ clientSecret, appearance }}
          >
            <EnterPaymentInfo
              clientSecret={clientSecret}
              setPaymentStep={setPaymentStep}
              setSessionId={setSessionId}
              setSuccess={setSuccess}
            />
          </Elements>
        </div>
      )}
      {success && <SuccessDisplay sessionId={sessionId} />}
    </div>
  );
}

ProductDisplay.propTypes = {
  setMessage: propTypes.func,
  setSuccess: propTypes.func,
  setSessionId: propTypes.func,
};

Message.propTypes = {
  message: propTypes.string,
};
